
import {Component, Vue, Watch} from "vue-property-decorator";
import {RouterNameEnum} from "@/router/router.types";
import {Menu, Icon, Row, FormModel} from "ant-design-vue";
import {VisitSupportMix} from "@/UI/pages/visitsNew/mixins/Support";
import {receiptVisitId} from "@/UI/pages/visitsNew/Lib/money";
import {mixins} from "vue-class-component";

@Component({
  components: {
    "a-icon": Icon,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-row": Row,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
  },
})

export default class VisitDialog extends mixins(
    VisitSupportMix,
) {
  creatingNewRecord: boolean = false;
  activeMenuItemKey: Array<any> = [];

  activeMenuItem(): void {
    let idx = "1";

    if (this.$router.currentRoute.name == "VisitsNew") idx = "1";
    if (this.$router.currentRoute.name == "VisitsNewStatus" || this.$router.currentRoute.name == "VisitsNewStatusFm") idx = "2";
    if (this.$router.currentRoute.name == "VisitsNewPay") idx = "3";
    if (this.$router.currentRoute.name == "VisitsNewHistory") idx = "4";
    if (this.$router.currentRoute.name == "VisitsNewProducts") idx = "5";

    this.activeMenuItemKey = [idx];
    return;
  }

  allowShowLinks(): boolean {
    let result = false;
    if (Vue.router.currentRoute.params["mode"] === "status") result = true;

    return result;
  }

  @Watch('$route', { immediate: true })
  onVisitRouteChange(): void {
    const id = this.$route.params.form ? receiptVisitId(this.$route.params) : this.$route.params.id;
    this.creatingNewRecord = this.$route.params.mode === 'create' && (!id || Number(id) === 0);
    this.activeMenuItem();
  }

  async mounted(): Promise<void> {
    // Only the initial parent route needs to open the empty details form.
    // A persisted visit must remain accessible even if its URL still says create.
    if (this.$route.name === RouterNameEnum.VisitsNewRecord && this.$route.params.mode === 'create') {
      await Vue.router.push({
        name: RouterNameEnum.VisitsNewDetail,
        params: { id: "0" },
      });
    }
  }

}
